import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import policyActions from '../../policy/policyActions';
import userActions from '../../user/userActions';

import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';
import { SecurityRoles as roles } from '../../common/utils';

import CustomerDetailsPage from './CustomerDetailsPage';
import CustomerPolicyPage from './CustomerPolicyPage';
import CustomerNotesPage from './CustomerNotesPage';
import { Page, PageContent, PageHeader, Spinner, Tabs } from '../../components/common';

interface Props {
	customer: UserDetails;
	currentUser: UserDetails;
	actions: any;
	history?: any;
	match?: any;
}
interface State {
	isLoading: boolean;
}
class ProspectPage extends React.Component<Props, State> {
	state = {
		isLoading: true
	};

	componentDidMount() {
		this.props.actions.resetCustomerPolicy();
		this.props.actions
			.fetchUser(this.props.match.params.customerId)
			.then(() => this.setState({ isLoading: false }));
	}

	getTab = (tabParam: string) => {
		let tab = null;
		switch (tabParam) {
			case 'policies':
				tab = CustomerPolicyPage;
				break;
			case 'notes':
				tab = CustomerNotesPage;
				break;
			case 'details':
			default:
				tab = CustomerDetailsPage;
				break;
		}

		return tab;
	}

	getTabProps = (tabName: string, allProps: any) => {
		let props: any;
		const { actions, history, match } = allProps;
		const { customer } = allProps;
		const { currentUser } = allProps;
		switch (tabName) {
			case 'policies':
				props = { match, history, currentUser };
				break;
			case 'notes':
				props = { customer, history, currentUser, match };
				break;
			case 'details':
			default: // details page
				props = { customer, currentUser, actions, match };
		}

		return props;
	}

	getTabTitle = (tabParam: string) => {
		let tabTitle = '';
		switch (tabParam) {
			case 'policies':
				tabTitle = 'Applications';
				break;
			case 'notes':
				tabTitle = 'Notes';
				break;
			case 'details':
			default:
				tabTitle = 'Contact info';
				break;
		}

		return tabTitle;
	}

	render() {
		const Tab = this.getTab(this.props.match.params.tab);
		const tabTitle = this.getTabTitle(this.props.match.params.tab);
		const props = this.getTabProps(this.props.match.params.tab, this.props);
		return (
			<Page title={`${this.props.customer.firstName} ${this.props.customer.lastName} - ${tabTitle}`}>
				<PageContent>
					<PageHeader className={`page-header-sm${this.state.isLoading ? ' loading' : ''}`}>
						<h1 className="mb-0 has-loading-text">
							{!this.state.isLoading && `${this.props.customer.firstName} ${this.props.customer.lastName}`}
						</h1>
					</PageHeader>
					<Tabs
						tabs={[
							{
								label: 'Contact info',
								to: `/admin/prospects/${this.props.match.params.customerId}/details`
							},
							{
								label: 'Applications',
								to: `/admin/prospects/${this.props.match.params.customerId}/policies`
							},
							{
								label: 'Notes',
								to: `/admin/prospects/${this.props.match.params.customerId}/notes`
							}
						]}
						match={this.props.match}
						disableDocTitle={true}
					/>
					{this.state.isLoading ? (
						<Spinner className="d-block mx-auto mt-4" />
					) : (
							<Tab className="tab-content mt-4 mt-lg-3" {...props} />
						)}
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		customer: state.user.user,
		currentUser: state.auth.currentUser
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions, ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(ProspectPage);
const adminRoles = [roles.Administrator, roles.Agent, roles.Adjudicator];
export default ensureUserHasRoleAdminSite(connectedPage as any, adminRoles);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/ProspectPage.tsx